// 取得の小さなフック。失敗を「読み込み中」のまま黙らせない（旧 ClientHub の問題）。
import { useCallback, useEffect, useRef, useState } from 'react';
import { messageOf } from './errors';

export interface Loaded<T> {
  data: T | null;
  error: string | null;
  loading: boolean;
  reload: () => void;
}

export function useLoad<T>(fn: (() => Promise<T>) | null, deps: unknown[]): Loaded<T> {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(!!fn);
  const [tick, setTick] = useState(0);
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    const f = fnRef.current;
    if (!f) {
      setLoading(false);
      return;
    }
    let alive = true;
    setLoading(true);
    setError(null);
    f()
      .then((d) => alive && setData(d))
      .catch((e) => alive && setError(messageOf(e)))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, tick]);

  const reload = useCallback(() => setTick((t) => t + 1), []);
  return { data, error, loading, reload };
}
